import DefaultLogo from "../../components/Logo"
import Logo from "./components/Logo"

const dashboard = {
    Logo: DefaultLogo,
    signInLogo: Logo,
}

export default dashboard
